import React from "react";

import { useEffect, useState } from "react";
import { fetchPageData } from "../endpoint/pageApi";
import MainLayout from "../layouts/MainLayout";
import boximg from "../assets/image/tempvideoboxforabout.png";
import icon1 from ".././assets/image/icon1.png";
import ShadowCard from "../components/ShadowCard/ShadowCard";
import PractitionersCrdBg from "../assets/image/PractitionersCrdBg.png";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../utils/mediaBreakpoints";
import PractitionersCarousel from "../components/Carousel/PractitionersCarousel";
import { baseUrl } from "../utils/base_url";
import { useNavigate } from "react-router-dom";

const MainAcademiaPage = ({ data }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const navigate = useNavigate();
  return (
    <>
      <div
        className="container-fluid m-0 p-0"
        style={{ backgroundColor: " #090D24" }}
      >
        <div className="row">
          <div className="col-12 pt-4 pb-5">
            <div className="container px-0 contwidth">
              {/* <div className="d-flex align-items-center justify-content-center pb-3">
                <img src={boximg} alt="" style={{ width: "100%" }} />
              </div> */}
              <PractitionersCarousel data={data} />

              <div className="text-center text-white w-100">
                <p
                  className="fw700 m-0 p-0 w-100 pt-3"
                  style={{
                    fontSize: _576
                      ? "30px"
                      : _768
                      ? "40px"
                      : _992
                      ? "49px"
                      : _1200
                      ? "54px"
                      : _1400
                      ? "60px"
                      : _1600
                      ? "70px"
                      : _1700
                      ? "80px"
                      : _1800
                      ? "90px"
                      : "90px",

                    lineHeight: _576
                      ? "30px"
                      : _768
                      ? "40px"
                      : _992
                      ? "49px"
                      : _1200
                      ? "54px"
                      : _1400
                      ? "59px"
                      : _1600
                      ? "64px"
                      : _1700
                      ? "79px"
                      : _1800
                      ? "89px"
                      : "100px",
                  }}
                >
                  {data?.about_header?.heading}
                </p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: data?.about_header?.sub_heading?.replace(
                      "for a",
                      "for a<br/>"
                    ),
                  }}
                  className={`fw700 w-100 pt-4`}
                  style={{
                    fontSize: _576
                      ? "15px"
                      : _768
                      ? "20px"
                      : _992
                      ? "20px"
                      : _1200
                      ? "25px"
                      : _1400
                      ? "30px"
                      : _1600
                      ? "35px"
                      : _1700
                      ? "40px"
                      : _1800
                      ? "40px"
                      : "40px",
                    lineHeight: "100%",
                    marginTop: "-1rem",
                    paddingBottom: "5rem",
                    // wordSpacing: "-5px",
                  }}
                  // style={{ lineHeight: "3rem", paddingBottom: "5rem",wordSpacing: "-5px" }}
                >
                  {/* {data?.about_header?.sub_heading} */}
                </p>
              </div>
            </div>
          </div>

          {/* <div className="col-12">
            <div
              className={`row g-0 ${
                _768px ? "" : "d-flex align-items-center justify-content-center"
              }`} style={{ height: _768?"28vh":"55vh" }}
            >
              <div
                className={`col-12  ${data?.column_view?.column_childs?.[0]?.left_col} d-flex ${_768?"justify-content-center":"justify-content-end"} align-items-end pb-1 pe-3`}
                style={{
                  backgroundColor:
                    data?.column_view?.column_childs?.[0]?.backgroundColor,
                  height: "100%",
                  lineHeight: _576
                    ? "1.5rem"
                    : _768
                    ? "1.5rem"
                    : _992
                    ? "1.5rem"
                    : _1200
                    ? "2rem"
                    : _1400
                    ? "2rem"
                    : _1600
                    ? "2.5rem"
                    : _1700
                    ? "2.6rem"
                    : _1800
                    ? "3rem"
                    : "3rem",
                }}
              >
                <p
                  dangerouslySetInnerHTML={{
                    __html: _768? data?.column_view?.column_childs?.[0]?.heading: data?.column_view?.column_childs?.[0]?.heading
                      ?.replace("assistance", "assistance<br/>")
                      ?.replace("case", "case<br/>"),
                  }}
                  className={`text-white ${_768?"text-center":"text-end"} fw800 `}
                  style={{
                    fontSize: _576
                      ? "20px"
                      : _768
                      ? "20px"
                      : _992
                      ? "20px"
                      : _1200
                      ? "25px"
                      : _1400
                      ? "30px"
                      : _1600
                      ? "35px"
                      : _1700
                      ? "40px"
                      : _1800
                      ? "45px"
                      : "45px",
                  }}
                ></p>
              </div>

              <div
                className={`col-12  ${data?.column_view?.column_childs?.[1]?.right_col} d-flex ${_768?"justify-content-center":"justify-content-start"} align-items-end pb-1 ps-3`}
                style={{
                  backgroundColor:
                    data?.column_view?.column_childs?.[1]?.backgroundColor,
                  height: "100%",
                  lineHeight: _576
                    ? "1.5rem"
                    : _768
                    ? "1.5rem"
                    : _992
                    ? "1.5rem"
                    : _1200
                    ? "2rem"
                    : _1400
                    ? "2rem"
                    : _1600
                    ? "2.5rem"
                    : _1700
                    ? "2.6rem"
                    : _1800
                    ? "3rem"
                    : "3rem",
                }}
              >
                <p
                  dangerouslySetInnerHTML={{
                    __html: _768? data?.column_view?.column_childs?.[1]?.heading:data?.column_view?.column_childs?.[1]?.heading
                      ?.replace("case", "case<br/>")
                      ?.replace("court", "court<br/>"),
                  }}
                  className={`text-white ${_768?"text-center":""} fw800 `}
                  style={{
                    fontSize: _576
                      ? "20px"
                      : _768
                      ? "20px"
                      : _992
                      ? "20px"
                      : _1200
                      ? "25px"
                      : _1400
                      ? "30px"
                      : _1600
                      ? "35px"
                      : _1700
                      ? "40px"
                      : _1800
                      ? "45px"
                      : "45px",
                  }}
                ></p>
              </div>
            </div>
          </div> */}

          <div className="col-12">
            <div
              className={`row g-0 ${
                _768px ? "" : "d-flex align-items-center justify-content-center"
              }`}
              style={{ height: _768 ? "28vh" : "55vh" }}
            >
              {data?.column_view?.column_childs?.map((item, index) => {
                console.log(item);
                const isVideo = item?.image?.mime?.includes("video");
                const bgUrl = item?.image?.url
                  ? `${baseUrl}${item.image.url}`
                  : "";
                const text = item?.heading;
                console.log(bgUrl, isVideo);

                const responsiveFontSize = _576
                  ? "20px"
                  : _768
                  ? "20px"
                  : _992
                  ? "20px"
                  : _1200
                  ? "25px"
                  : _1400
                  ? "30px"
                  : _1600
                  ? "35px"
                  : _1700
                  ? "40px"
                  : _1800
                  ? "45px"
                  : "45px";

                const responsiveLineHeight = _576
                  ? "1.5rem"
                  : _768
                  ? "1.5rem"
                  : _992
                  ? "1.5rem"
                  : _1200
                  ? "2rem"
                  : _1400
                  ? "2rem"
                  : _1600
                  ? "2.5rem"
                  : _1700
                  ? "2.6rem"
                  : _1800
                  ? "3rem"
                  : "3rem";

                // Optional: Custom line breaks
                const finalText = !_768
                  ? text
                      ?.replace(/assistance/g, "assistance<br/>")
                      ?.replace(/case/g, "case<br/>")
                      ?.replace(/court/g, "court<br/>")
                  : text;

                return (
                  <div
                    key={index}
                    className={`col-12 ${
                      item?.left_col || item?.right_col
                    } d-flex ${
                      _768
                        ? "justify-content-center"
                        : index === 0
                        ? "justify-content-end pe-3"
                        : "justify-content-start ps-3"
                    } align-items-end pb-1 position-relative overflow-hidden`}
                    style={{
                      backgroundColor: item?.backgroundColor,
                      height: "100%",
                      backgroundImage: !isVideo ? `url(${bgUrl})` : undefined,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      overflow: "hidden",
                      lineHeight: responsiveLineHeight,
                    }}
                  >
                    {/* Background video if applicable */}
                    {isVideo && (
                      <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover z-n1"
                      >
                        <source src={`${bgUrl}`} type="video/mp4" />
                      </video>
                    )}

                    {/* Background image if not video */}
                    {/* {!isVideo && bgUrl && (
                      <div
                        className="position-absolute top-0 start-0 w-100 h-100 z-n1"
                        style={{
                          // backgroundImage: `url(${bgUrl})`,
                          background: "url(http://18.203.133.130:1337/uploads/Group_4026_60bde7a6f8.png)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                    )} */}

                    {/* Text content */}
                    <p
                      className={`text-white fw800 ${
                        _768 ? "text-center" : index === 0 ? "text-end" : ""
                      }`}
                      style={{
                        fontSize: responsiveFontSize,
                        zIndex: 2,
                      }}
                      dangerouslySetInnerHTML={{ __html: finalText }}
                    ></p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="col-12" style={{ marginTop: _768 ? "13rem" : "" }}>
            <div className="position-relative overflow-hidden">
              <img
                src={PractitionersCrdBg}
                alt=""
                className="position-absolute start-50"
                style={{
                  top: _576
                    ? "55%"
                    : _768
                    ? "55%"
                    : _992
                    ? "53%"
                    : _1500
                    ? "43%"
                    : "43%",
                  transform: "translateX(-50%)",
                  height: "350px",
                  width: "100%",
                  zIndex: 0,
                  objectFit: "cover",
                  opacity: 0.5,
                }}
              />
              <div
                className="position-absolute start-50"
                style={{
                  top: _576
                    ? "55%"
                    : _768
                    ? "55%"
                    : _992
                    ? "53%"
                    : _1500
                    ? "43%"
                    : "43%",
                  transform: "translateX(-50%)",
                  height: "350px",
                  width: "100%",
                  backgroundColor: " #00165B",
                  mixBlendMode: "overlay",
                  pointerEvents: "none",
                  zIndex: 1,
                  opacity: 0.8,
                }}
              />

              <p
                className="fw400  text-white text-center px-3 px-md-0"
                style={{
                  padding: _768 ? `5rem 0` : "5rem 0",
                  fontSize: _576
                    ? "20px"
                    : _768
                    ? "25px"
                    : _992
                    ? "30px"
                    : _1200
                    ? "35px"
                    : _1400
                    ? "40px"
                    : _1600
                    ? "50px"
                    : _1700
                    ? "55px"
                    : _1800
                    ? "60px"
                    : "60px",
                }}
                dangerouslySetInnerHTML={{
                  __html: data?.info_cards?.heading_1?.replace(
                    "theory and practice",
                    '<span style="border-bottom: 5px solid #0039EC " }}>theory and practice</span>'
                  ),
                }}
              ></p>

              <div
                className="container contWidth"
                style={{ position: "relative", zIndex: 1 }}
              >
                <div className="row justify-content-center pt-5">
                  <div className="d-none d-md-block col-lg-2 px-3"></div>
                  {data?.info_cards?.details
                    ?.slice(0, 2)
                    ?.map((card, index) => (
                      <div
                        onClick={() =>
                          navigate(index === 0 ? "/scholars" : "/law-students")
                        }
                        key={index}
                        className="cursor-pointer col-12 col-lg-4 mb-5 mb-lg-0 px-4 px-sm-0 px-lg-2 px-xl-4 "
                      >
                        <ShadowCard
                          isCrdWhite={false}
                          topIcon={card?.top_icon?.url}
                          text={card?.sub_heading}
                          topHeading={card?.heading}
                          textClass={`fw400 ${
                            _576
                              ? "fs18"
                              : _768
                              ? "fs20"
                              : _992
                              ? "fs18"
                              : _1200
                              ? "fs18"
                              : _1400
                              ? "fs16"
                              : _1500
                              ? "fs16"
                              : _1600
                              ? "fs16"
                              : _1700
                              ? "fs18"
                              : _1800
                              ? "fs18"
                              : "fs20"
                          }`}
                          headingClass={`fw800 ${
                            _576
                              ? "fs26"
                              : _768
                              ? "fs35"
                              : _992
                              ? "fs35"
                              : _1200
                              ? "fs28"
                              : _1400
                              ? "fs26"
                              : _1500
                              ? "fs28"
                              : _1600
                              ? "fs28"
                              : _1700
                              ? "fs32"
                              : _1800
                              ? "fs35"
                              : "fs40"
                          } `}
                          lineColor={card?.horizontal_line_color}
                          topIConHeight={card?.top_icon?.height}
                          topIConWidth={card?.top_icon?.width}
                          imgurl={card?.card_no?.url}
                        />
                      </div>
                    ))}
                  <div className="d-none d-md-block col-lg-2 px-3"></div>
                </div>

                <p
                  className="fw700 text-white text-center py-4"
                  style={{
                    fontSize: _576
                      ? "30px"
                      : _768
                      ? "35px"
                      : _992
                      ? "35px"
                      : _1200
                      ? "35px"
                      : _1400
                      ? "40px"
                      : _1600
                      ? "45px"
                      : _1800
                      ? "50px"
                      : "60px",
                  }}
                >
                  {data?.info_cards?.heading_2}
                </p>

                <div className="row justify-content-center pb-5">
                  <div className="d-none d-md-block col-lg-4 px-3 "></div>
                  {data?.info_cards?.details
                    ?.slice(2, 4)
                    ?.map((card, index) => (
                      <div
                        onClick={() =>
                          navigate(index === 0 ? "/law-schools" : "")
                        }
                        key={index}
                        className="curcor-pointer col-12 col-lg-4 mb-5 mb-lg-0 py-5 px-xl-5"
                      >
                        <ShadowCard
                          isCrdWhite={false}
                          topIcon={card?.top_icon?.url}
                          text={card?.sub_heading}
                          topHeading={card?.heading}
                          textClass={`fw400 ${
                            _576
                              ? "fs18"
                              : _768
                              ? "fs20"
                              : _992
                              ? "fs18"
                              : _1200
                              ? "fs18"
                              : _1400
                              ? "fs16"
                              : _1500
                              ? "fs16"
                              : _1600
                              ? "fs16"
                              : _1700
                              ? "fs18"
                              : _1800
                              ? "fs18"
                              : "fs20"
                          }`}
                          headingClass={`fw800 ${
                            _576
                              ? "fs26"
                              : _768
                              ? "fs35"
                              : _992
                              ? "fs35"
                              : _1200
                              ? "fs28"
                              : _1400
                              ? "fs26"
                              : _1500
                              ? "fs28"
                              : _1600
                              ? "fs28"
                              : _1700
                              ? "fs32"
                              : _1800
                              ? "fs35"
                              : "fs40"
                          } `}
                          lineColor={card?.horizontal_line_color}
                          topIConHeight={card?.top_icon?.height}
                          topIConWidth={card?.top_icon?.width}
                          imgurl={card?.card_no?.url}
                        />
                      </div>
                    ))}
                  <div className="d-none d-md-block col-lg-4 px-3"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Academia = () => {
  const [pageData, setPageData] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchPageData("pages?filters[slug][$eq]=academia", setPageData, setLoader);
  }, []);
  return (
    <>
      <MainLayout loader={loader}>
        <div className="container-fluid  p-0 overflow-x-hidden">
          <MainAcademiaPage data={pageData} />
        </div>
      </MainLayout>
    </>
  );
};

export default Academia;
